import $ from 'jquery';

import 'popper.js';
import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
import 'bootstrap/js/dist/tooltip';

if (!window.HTMLPictureElement) {
    import('picturefill');
}


let _config = window['_config'] || {};

window.app = window.app || {};
window.app.modules =  window.app.modules || {};

let app = window.app;


import initModulesInScope from "@elements/init-modules-in-scope";
app.initModules = function ($scope) {
    console.warn('\'app.initModules\' is going to be deprecated and should not be used anymore. Please import and use \'initModulesInScope\' from \'./scripts/initModulesInScope\' instead.');
    initModulesInScope($scope);
};

$.loadScript = function (url) {
    console.warn('\'$.loadScript\' is going to be deprecated and should not be used anymore. Please use \'import\' for local files or import and use \'loadScript\' for external resources.');

    return import('@elements/load-script').then(function (loadScript) {
        return loadScript.default(url);
    });
};

import './scripts/common';

/* Common */
import * as menuAim from './scripts/menu-aim';
app.modules.menuAim = menuAim.initInScope;

import * as touchNav from './scripts/touch-nav';
app.modules.touchNav = touchNav.initInScope;

import * as nav from './scripts/nav';
app.modules.nav = nav.initInScope;

import * as renderTemplate from './scripts/render-template';
app.modules.renderTemplate = renderTemplate.initInScope;

import * as goToLink from '@elements/go-to-link';
app.goToLink = goToLink.init;

import * as toc from '@elements/toc';
app.toc = toc.init;
app.modules.toc = toc.initInScope;

import * as findologic from './scripts/findologic';
app.modules.findologic = findologic.initInScope;

import * as overlay from './scripts/overlay';
app.overlay = overlay.init;
app.modules.overlay = overlay.initInScope;

import * as general from './scripts/general';
app.modules.general = general.initInScope;

import * as affix from '@elements/affix';
app.modules.affix = affix.initInScope;

app.modules.navAffix = affix.createInitInScope(
    {
        mediaQuery: '(min-width: 768px)'
    },
    {
        base: '.js-nav-affix',
        placeholder: '.js-affix__placeholder',
        container: '.js-affix__container'

    });

import * as affixNavbar from './scripts/affix-navbar';
app.affixNavbar = affixNavbar.init;

import * as matchmediaViewer from "./scripts/matchmedia-viewer";
app.matchmediaViewer = matchmediaViewer.init;
app.modules.matchmediaViewer = matchmediaViewer.initInScope;

import * as reloadForm from "@elements/reload-form";
app.modules.reloadForm = reloadForm.initInScope;

import * as popinModal from './scripts/popin-modal';
app.popinModal = popinModal.init;

import * as searchBar from './scripts/searchBar';
app.modules.searchBar = searchBar.initInScope;

import * as wishlist from './scripts/wishlist';
app.wishlist = wishlist.init;
app.modules.wishlist = wishlist.initInScope;


import * as comparelist from './scripts/compare-list';
app.comparelist = comparelist.init;
app.modules.comparelist = comparelist.initInScope;

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

import * as lightbox from '@elements/lightbox';
app.modules.lightbox = lightbox.initInScope;

import * as ajaxForm from '@elements/ajax-form';
app.modules.ajaxForm = ajaxForm.initInScope;

import * as ajaxFormMap from './scripts/ajax-form-map';
app.modules.ajaxFormMap = ajaxFormMap.initInScope;

import * as ajaxFormScroll from './scripts/ajax-form-scroll';
app.modules.ajaxFormScroll = ajaxFormScroll.initInScope;

import * as googleMap from './scripts/google-map';
app.modules.googleMap = googleMap.initInScope;

import * as geoLocation from './scripts/geolocation';
app.modules.geoLocation = geoLocation.initInScope;

import * as imageThumbSwiper from './scripts/image-thumb-swiper';
app.modules.imageThumbSwiper = imageThumbSwiper.initInScope;

import * as loadStoreInfo from './scripts/load-store-info';
app.modules.loadStoreInfo = loadStoreInfo.initInScope;

import * as myStore from './scripts/my-store';
app.modules.myStore = myStore.initInScope;

(function( $ ){
    "use strict";

    /* -> _config._preload = Load this functions first */
    if (_config['_preload']) {
        $.each( _config['_preload'], function( _key, _val ){
            if( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ){
                window.app[_key]();
            }
        });
    }

    /* -> _config = Load all others (not _preload and _reload) */
    $.each( _config, function( _key, _val ){
        // console.log('key',_key)
        // console.log('val',_val)
        if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' && _key != '_reload' && _key != '_preload' ) ){
            window.app[_key]();
        }
    });

    /* -> _config._reload = Load the ajaxInclued and others after the rest */
    if (_config['_reload']) {
        $.each( _config['_reload'], function( _key, _val ){
            if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ) ){
                window.app[_key]();
            }
        });
    }

    initModulesInScope();
})($);

$(function($) {
   $('.store-teaser-list-overflow').scroll( function() {
       if($(this)[0].scrollHeight - $(this).scrollTop() <= $(this).outerHeight()+10){
            $('.js-store-locator-gradient').removeClass('store-locator__gradient');
        } else{
            $('.js-store-locator-gradient').addClass('store-locator__gradient');
        }
   })
});


